import {
  ICheckIfShouldShowSideBar, IForm1065, IForm1120s, IFormList,
} from './interfaces';

export const serializeFormsList = (data : IForm1065 & IForm1120s) => {
  if (data.form1065s) {
    const copyList = [...data.form1065s];
    copyList.forEach(formObj => {
      formObj.formId = formObj.form1065Id || '';
      // @ts-ignore
      delete formObj.form1065Id;
    });
    return copyList as IFormList;
  }
  if (data.form1120s) {
    const copyList = [...data.form1120s];
    copyList.forEach(formObj => {
      formObj.formId = formObj.form1120Id || '';
      // @ts-ignore
      delete formObj.form1065Id;
    });
    return copyList as IFormList;
  }
  return null;
};

export const checkIfShouldShowSideBar = ({ list }: ICheckIfShouldShowSideBar) => {
  if (!list.length) return false;
  if (list.some(item => item.fileCreated)) return true;
  if (list.length === 1 && !list[0].fileCreated) {
    return false;
  } if (list.length > 1) {
    return true;
  }
  return true;
};

export const exportAndSortYearsList = (list: IFormList) => {
  const years = list.map(item => item.year);
  return years.sort((a, b) => b - a);
};

export const getFormNumber = (type: string | undefined) => {
  if (type === 'ScheduleK') {
    return '1065';
  } if (type === 'Form1120s') {
    return '1120-s';
  } if (type === 'Form1120') {
    return '1120';
  }
  return '';
};
